// extracted by mini-css-extract-plugin
export default {"pagination_container":"styles_pagination_container__94NKu","pagination_button":"styles_pagination_button__GF1c1"};